
export class CeDocInfo {
    'id' = '';
    'type' = '';
    'translations': Array<string> = [];
    'witnesses': Array<CeDocInfoWitness> = [];
    'date' = '';
    'version' = '';
}

export interface CeDocInfoWitness {
    'witness': string;
    'hands': Array<string>;
}



// WEBPACK FOOTER //
// ./src/app/models/ce-doc-info.ts